<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div v-if="token !== null" class="container-fluid">
      <!-- <a class="navbar-brand" href="#">{{routeName}}</a> -->
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <!-- <div class="collapse navbar-collapse">

      </div>-->
      <div class="logout-panel">
        <!--drop-down
          class="nav-item logout-panel__settings"
          title="SETTINGS"
          title-classes="nav-link"
          icon="ti-settings"
        >
          <a class="dropdown-item" href="#" @click="showTutorial">Show tutorial</a>
        </drop-down-->
        <div class="logout-panel__form">
          <div class="logout-panel__username">
            <strong>{{ userName }}</strong>
          </div>
          <button class="logout-panel__btn" @click="onLogout">Logout</button>
        </div>
        <div class="logout-panel__logo-wrapper">
          <img src="../../assets/img/user.svg" alt class="logout-panel__logo" />
        </div>
      </div>
    </div>
    <div v-else class="container-fluid">
      <a class="navbar-brand" href="#">{{ routeName }}</a>
    </div>
  </nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    token() {
      return this.$store.getters.token;
    },
    userName() {
      return this.$store.getters.username;
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    onLogout() {
      this.$store.dispatch("logout");
    },
    showTutorial() {
      this.$store.dispatch("openLoginModal", true);
    }
  }
};
</script>
<style lang="scss">
.custom-login {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin: 5px;
  }
}

.logout-panel {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-right: 30px;

  @media only screen and (max-width: 990px) {
    width: auto;
  }

  &__settings {
    list-style-type: none;
    margin-right: 15px;

    i {
      font-size: 20px !important;
      position: relative;
      top: 4px;
      right: 3px;
      margin-right: 5px;
    }
  }

  &__username {
    text-transform: uppercase;
  }

  &__btn {
    color: rgb(136, 134, 134);
    background-color: transparent;
    border: none;
    padding: 0px;
  }

  &__form {
    text-align: right;
    margin-right: 15px;
  }

  &__logo {
    width: 16px;
  }

  &__logo-wrapper {
    border: 1px solid #888686;
    border-radius: 50%;
    width: 45px;
    height: 45px;

    display: flex;
    justify-content: center;
    text-align: center;
  }
}
</style>
